// src/data/techStackData.js

export const techStackData = [
  {
    name: 'React',
    imageUrl: '/images/logos/react1.png',
    altText: 'Logo React',
    category: 'Frontend Framework/Library',
    utility: 'Création d\'interfaces utilisateur dynamiques et performantes.'
  },
  {
    name: 'Figma',
    imageUrl: '/images/logos/figma1.png',
    altText: 'Logo Figma',
    category: 'Design & Prototypage',
    utility: 'Outil de conception collaborative pour interfaces utilisateur et prototypes.'
  },
  {
    name: 'Supabase',
    imageUrl: '/images/logos/supabase1.png',
    altText: 'Logo Supabase',
    category: 'Backend & Database',
    utility: 'Alternative open-source à Firebase offrant base de données, authentification, stockage.'
  },
  {
    name: 'WordPress',
    imageUrl: '/images/logos/wordpress1.png',
    altText: 'Logo WordPress',
    category: 'CMS & Web Development',
    utility: 'Système de gestion de contenu populaire pour la création de sites web et blogs.'
  },
  {
    name: 'TypeScript',
    imageUrl: '/images/logos/ts.png',
    altText: 'Logo TypeScript',
    category: 'Langage de Programmation',
    utility: 'Sur-ensemble de JavaScript ajoutant un typage statique optionnel.'
  },
  {
    name: 'UI Design',
    imageUrl: '/images/logos/ui.png',
    altText: 'Logo UI Design',
    category: 'Design',
    utility: 'Conception de l\'interface utilisateur pour une expérience esthétique et fonctionnelle.'
  },
  {
    name: 'Vue.js',
    imageUrl: '/images/logos/vu.png',
    altText: 'Logo Vue.js',
    category: 'Frontend Framework/Library',
    utility: 'Framework JavaScript progressif pour la construction d\'interfaces utilisateur.'
  },
  {
    name: 'Next.js',
    imageUrl: '/images/logos/next1.jpg', // Utilise next.png (next1.jpg est aussi disponible dans votre liste de 104 fichiers)
    altText: 'Logo Next.js',
    category: 'Frontend Framework (React)',
    utility: 'Framework React pour la production, offrant rendu côté serveur, génération statique et plus.'
  },

  {
    name: 'CSS3',
    imageUrl: '/images/logos/css.png',
    altText: 'Logo CSS3',
    category: 'Frontend Development',
    utility: 'Langage de feuilles de style pour la présentation des documents HTML et XML.'
  },
  {
    name: 'Flutter',
    imageUrl: '/images/logos/flutter1.png',
    altText: 'Logo Flutter',
    category: 'Mobile Development',
    utility: 'SDK UI de Google pour créer des applications compilées nativement pour mobile, web et bureau.'
  },
  {
    name: 'Firebase',
    imageUrl: '/images/logos/firebase1.png',
    altText: 'Logo Firebase',
    category: 'Backend & Database',
    utility: 'Plateforme de développement d\'applications mobiles et web de Google (BaaS).'
  },
  {
    name: 'GitHub',
    imageUrl: '/images/logos/github.png',
    altText: 'Logo GitHub',
    category: 'Version Control & Collaboration',
    utility: 'Plateforme d\'hébergement de code et de collaboration utilisant Git.'
  },
  {
    name: 'HTML5',
    imageUrl: '/images/logos/html.png',
    altText: 'Logo HTML5',
    category: 'Frontend Development',
    utility: 'Langage de balisage standard pour la création de pages web.'
  },
  {
    name: 'JavaScript',
    imageUrl: '/images/logos/js.png',
    altText: 'Logo JavaScript',
    category: 'Langage de Programmation',
    utility: 'Langage de script essentiel pour le développement web frontend et backend (Node.js).'
  },
  {
    name: 'Unity',
    imageUrl: '/images/logos/unity.png',
    altText: 'Logo Unity',
    category: 'Développement de Jeux & 3D',
    utility: 'Moteur de jeu multiplateforme pour créer des expériences 2D, 3D, VR et AR.'
  },
  {
    name: 'Vite',
    imageUrl: '/images/logos/vite.png',
    altText: 'Logo Vite',
    category: 'Outils de Build Frontend',
    utility: 'Outil de build frontend rapide et moderne, offrant un serveur de développement instantané.'
  },
  {
    name: 'Node.js',
    imageUrl: '/images/logos/node.png',
    altText: 'Logo Node.js',
    category: 'Backend Runtime Environment',
    utility: 'Permet d\'exécuter JavaScript côté serveur, idéal pour les API et applications web scalables.'
  },
  {
    name: 'Python',
    imageUrl: '/images/logos/python2.png',
    altText: 'Logo Python',
    category: 'Langage de Programmation',
    utility: 'Langage polyvalent utilisé pour le développement web, la science des données, l\'IA, les scripts.'
  },
  {
    name: 'MongoDB',
    imageUrl: '/images/logos/mongo.png',
    altText: 'Logo MongoDB',
    category: 'Database',
    utility: 'Base de données NoSQL orientée documents, flexible et scalable.'
  },
  {
    name: 'Angular',
    imageUrl: '/images/logos/angular.png',
    altText: 'Logo Angular',
    category: 'Frontend Framework',
    utility: 'Framework frontend maintenu par Google pour construire des applications web monopages (SPA) robustes.'
  },
  {
    name: 'Django',
    imageUrl: '/images/logos/django.png',
    altText: 'Logo Django',
    category: 'Backend Framework (Python)',
    utility: 'Framework web Python de haut niveau qui encourage un développement rapide et une conception propre et pragmatique.'
  },
  {
    name: 'Java',
    imageUrl: '/images/logos/java.png',
    altText: 'Logo Java',
    category: 'Langage de Programmation',
    utility: 'Langage de programmation polyvalent, orienté objet, largement utilisé pour les applications d\'entreprise, Android et plus.'
  },
  {
    name: 'Bootstrap',
    imageUrl: '/images/logos/bootstrap.png',
    altText: 'Logo Bootstrap',
    category: 'Frontend Framework (CSS)',
    utility: 'Framework CSS populaire pour développer des sites web responsives et mobile-first rapidement.'
  },
  // 3 nouvelles technologies ajoutées :
  {
    name: 'Next.js',
    imageUrl: '/images/logos/next.png', // Utilise next.png (next1.jpg est aussi disponible dans votre liste de 104 fichiers)
    altText: 'Logo Next.js',
    category: 'Frontend Framework (React)',
    utility: 'Framework React pour la production, offrant rendu côté serveur, génération statique et plus.'
  },
  {
    name: 'GraphQL',
    imageUrl: '/images/logos/graphql.png',
    altText: 'Logo GraphQL',
    category: 'Query Language & API',
    utility: 'Langage de requête pour API et un runtime côté serveur pour exécuter ces requêtes avec vos données existantes.'
  },
  {
    name: 'Redis',
    imageUrl: '/images/logos/redis.png',
    altText: 'Logo Redis',
    category: 'Database & Cache',
    utility: 'Magasin de structures de données en mémoire, utilisé comme base de données, cache et courtier de messages.'
  }, 
  {
    name: 'PostgreSQL',
    imageUrl: '/images/logos/postgres.png',
    altText: 'Logo PostgreSQL',
    category: 'Database',
    utility: 'Système de gestion de base de données relationnelle objet puissant et open-source.'
  },
  {
    name: 'Ruby on Rails',
    imageUrl: '/images/logos/rails.png',
    altText: 'Logo Ruby on Rails',
    category: 'Backend Framework (Ruby)',
    utility: 'Framework de développement web côté serveur écrit en Ruby, optimisé pour la productivité des développeurs.'
  },
  {
    name: 'Webpack',
    imageUrl: '/images/logos/webpack.png',
    altText: 'Logo Webpack',
    category: 'Outils de Build Frontend',
    utility: 'Module bundler pour JavaScript, utilisé pour compiler des modules JavaScript, mais peut transformer d\'autres assets.'
  }
];